export default "__VITE_ASSET__bad1c5c5__"